// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b909262aea3e8feaab733933f65ca01052a07c74.chunk.bundle.js";
};